/**
 * This utility suppresses specific browser console errors that are not critical
 * to application functionality. These errors are often from third-party libraries
 * or browser quirks and can clutter the console.
 */

// Suppresses ResizeObserver loop limit exceeded error
// This error occurs commonly with UI libraries and doesn't impact functionality
export const suppressResizeObserverErrors = () => {
  const originalError = window.console.error;
  window.console.error = (...args) => {
    // Don't log ResizeObserver errors to console
    if (args[0]?.toString().includes('ResizeObserver loop') || 
        (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop'))) {
      // Optionally, we could log a more readable message 
      // console.log('Suppressed ResizeObserver error (normal browser behavior)');
      return;
    }
    originalError.apply(window.console, args);
  };
};

// Suppresses timeout related errors
export const suppressTimeoutErrors = () => {
  // Handle unhandled promise rejections related to timeouts
  window.addEventListener('unhandledrejection', event => {
    // Check if the error is related to a timeout
    if (event?.reason?.message?.includes('timeout') || 
        event?.reason?.message?.includes('timed out')) {
      // Prevent the error from appearing in console
      event.preventDefault();
      // Optionally log a cleaner message
      console.log('Background operation timed out - continuing processing');
    }
  });
};

// Export a function to apply all error suppressions
export const applyErrorSuppression = () => {
  suppressResizeObserverErrors();
  suppressTimeoutErrors();
};

// Default export for easier imports
export default applyErrorSuppression;